import appRoutes, { dashboardRoutes } from "constants/routeConstants";
import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Card, Segment, Statistic } from "semantic-ui-react";

function VendorMetadata() {
	const { suppliers, products, categories } = useSelector((state) => state);
	return (
		<Segment style={{ backgroundColor: "#4b4b4b" }}>
			<p style={{ color: "white" }}>Vendor Metadata</p>
			<Card.Group itemsPerRow={3}>
				{[
					{
						link: dashboardRoutes.VIEWPRODUCTS,
						title: "Total Products",
						value: products.allProducts?.length ?? 0,
					},
					{
						link: dashboardRoutes.VIEWCATEGORIES,
						title: "Total Categories",
						value: categories.allCategories?.length ?? 0,
					},
					{
						link: dashboardRoutes.VIEWSUPPLIERS,
						title: "Total Suppliers",
						value: suppliers.allSuppliers?.length ?? 0,
					},
				].map((item) => (
					<Card key={item.link} style={{ height: "inherit" }}>
						<Link to={appRoutes.DASHBOARD + item.link}>
							<Segment
								textAlign="center"
								style={{ height: "100% !important" }}
								padded="very"
							>
								<Statistic
									size="small"
									label={item.title}
									value={item.value}
								/>
							</Segment>
						</Link>
					</Card>
				))}
			</Card.Group>
		</Segment>
	);
}

export default VendorMetadata;
